import classNames from 'classnames/bind';
import React from 'react';

import styles from './FieldRow.module.scss';

const cx = classNames.bind(styles);

const FieldRow = ({ label, unit, children, height }) => {
  return (
    <div className={cx('container')}>
      <label style={height && { height }}>
        {label ? label : <span />}
        <div className={cx('wrapper')}>
          {children}
          <span className={cx('unit')}>{unit}</span>
        </div>
      </label>
    </div>
  );
};

export default FieldRow;
